angular.module('dnecom')
    .controller('StoreGeneralMobileProductPageSettingsController', ["$scope", function ($scope) {
        $scope.defaultProperties = {
            title: 'above_the_image',
            description: 'below_the_image',
            description_display: 'expanded'
        };

        if (!$scope.store.mobileProperties.hasOwnProperty('productPageLayout')) {
            $scope.store.mobileProperties.productPageLayout = angular.copy($scope.defaultProperties);
            $scope.$parent.originalStore = angular.copy($scope.store);
        }

        $scope.propertiesIsDefault = function() {
            return angular.equals($scope.store.mobileProperties.productPageLayout, $scope.defaultProperties);
        };

        $scope.reset = function () {
            $scope.store.mobileProperties.productPageLayout = angular.copy($scope.defaultProperties);
        };
    }]);
